import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  RightContainer,
  Title,
  DescriptionInput,
  DescriptionText,
} from "./styled.js";
import DescriptionIcon from "@mui/icons-material/TextSnippetOutlined";
import BottomButtonGroup from "../../../Pages/BoardPage/BoardComponents/BottomButtonGroup/BottomButtonGroup.js";
import { useDispatch, useSelector } from "react-redux";
import { addQuantidadeExecutada } from "../../../../Services/cardService.js";

const QuantidadeExecutada = () => {
  const thisCard = useSelector((state) => state.card);

  const dispatch = useDispatch();
  const [inputFocus, setInputFocus] = useState(false);
  const [quantidadeExecutada, setQuantidadeExecutada] = useState(
    thisCard.quantidadeExecutada
  );
  const ref = useRef();
  const ref2 = useRef();

  const handleSaveClick = async () => {
    setInputFocus(false);
    await addQuantidadeExecutada(
      thisCard.cardId,
      thisCard.listId,
      thisCard.boardId,
      quantidadeExecutada,
      dispatch
    );
  };

  useEffect(() => {
    setQuantidadeExecutada(thisCard.quantidadeExecutada);
  }, [thisCard.quantidadeExecutada]);

  useEffect(() => {
    if (inputFocus) {
      ref.current.focus();
    }
  }, [inputFocus]);

  const handleClickOutside = (event) => {
    if (ref2.current && !ref2.current.contains(event.target)) {
      setInputFocus(false);
      setQuantidadeExecutada(thisCard.quantidadeExecutada);
    } else {
      setInputFocus(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return (
    <Container ref={ref2}>
      <DescriptionIcon fontSize="small" />
      <RightContainer>
        <Title>Quantidade Executada</Title>
        {quantidadeExecutada && !inputFocus ? (
          <DescriptionText onClick={() => setInputFocus(true)}>
            {quantidadeExecutada}
          </DescriptionText>
        ) : (
          <DescriptionInput
            ref={ref}
            minHeight={inputFocus ? "5.5rem" : "2.5rem"}
            placeholder="Quant. Executada..."
            value={quantidadeExecutada}
            onChange={(e) => setQuantidadeExecutada(e.target.value)}
          />
        )}
        <div style={{ display: inputFocus ? "block" : "none" }}>
          <BottomButtonGroup
            closeCallback={() => {
              setInputFocus(false);
              setQuantidadeExecutada(thisCard.quantidadeExecutada);
            }}
            clickCallback={handleSaveClick}
            title="Salvar"
          />
        </div>
      </RightContainer>
    </Container>
  );
};

export default QuantidadeExecutada;
